export function isMobile(): boolean {
  console.log('navigator.userAgent===', navigator.userAgent);
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}
